import React, {useRef, useCallback} from "react";
import {PhotoProvider, PhotoView} from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

const FileImageShow = ({file: {FileName}, url, onLoadFile, onCloseClick}) => {
    const triggerRef = useRef(null);

    const handleClick = useCallback(
        (e) => {
            const mask = document.querySelector(".PhotoView__PhotoWrap");
            const photo = document.querySelector(".PhotoView__Photo");

            if (
                mask &&
                photo &&
                mask.contains(e.target) &&
                !photo.contains(e.target)
            ) {
                onCloseClick?.();
            }
        },
        [onCloseClick]
    );

    const handleImageLoad = () => {
        onLoadFile?.();
        setTimeout(() => {
            triggerRef.current?.click();
            document.addEventListener("click", handleClick, true);
        }, 0);
    };

    const handleVisibleChange = useCallback(
        (visible) => {
            if (!visible) {
                onCloseClick?.();
                document.removeEventListener("click", handleClick, true);
            } else {
                setTimeout(() => {
                    const counter = document.querySelector(
                        ".PhotoView-Slider__Counter"
                    );
                    if (counter && !counter.innerText.includes(FileName)) {
                        counter.innerText = `${FileName}`;
                    }
                }, 50);
            }
        },
        [onCloseClick, FileName, handleClick]
    );

    if (!url) return null;

    return (
        <PhotoProvider
            maskOpacity={0.8}
            maskClosable={false}
            onVisibleChange={handleVisibleChange}>
            <PhotoView src={url}>
                <img
                    data-testid="image-element"
                    ref={triggerRef}
                    src={url}
                    alt={FileName}
                    draggable={false}
                    onLoad={handleImageLoad}
                    style={{
                        display: "none", // ukrywamy miniaturkę
                    }}
                />
            </PhotoView>
        </PhotoProvider>
    );
};

export default FileImageShow;
